import React, { createContext, useContext, useState, useEffect } from "react";

const CartContext = createContext();

export const CartProvider = ({ children }) => {
  const [cart, setCart] = useState(() => {
    try {
      const savedCart = localStorage.getItem("cart");
      return savedCart ? JSON.parse(savedCart) : {};
    } catch (error) {
      console.error("Error parsing cart from localStorage:", error);
      return {};
    }
  });

  useEffect(() => {
    localStorage.setItem("cart", JSON.stringify(cart));
  }, [cart]);

  const loginData = JSON.parse(localStorage.getItem("loginData"));
  const userId = loginData?.user?._id || "guest";

  const addToCart = (item) => {
    setCart((prev) => {
      const currentUserId = loginData?.user?._id || "guest"; 
      const updatedCart = { ...prev };
      const userCart = updatedCart[currentUserId] || [];
  
      const itemExists = userCart.some(cartItem => cartItem.experienceData._id === item.experienceData._id);
      
      if (itemExists) {
        console.warn("Item is already in the cart.");
        return prev;
      }
  
      updatedCart[currentUserId] = [...userCart, item];
      localStorage.setItem("cart", JSON.stringify(updatedCart));
      return updatedCart;
    });
  };
  
  

  const removeFromCart = (experienceId) => {
    setCart((prev) => {
      const updatedCart = { ...prev };
  
      const loginData = JSON.parse(localStorage.getItem("loginData"));
      const currentUserId = loginData?.user?._id || "guest"; 
  
      if (updatedCart[currentUserId]) {
        updatedCart[currentUserId] = updatedCart[currentUserId].filter(
          (item) => item.experienceData._id !== experienceId
        );
  
        if (updatedCart[currentUserId].length === 0) {
          delete updatedCart[currentUserId];
        }
      }
  
      localStorage.setItem("cart", JSON.stringify(updatedCart));
  
      return updatedCart;
    });
  };
  
  

  return (
    <CartContext.Provider value={{ cart, setCart, addToCart, removeFromCart }}>
      {children}
    </CartContext.Provider>
  );
};

export const useCart = () => {
  return useContext(CartContext);
};
